import { addStyles } from 'ethcss'
import { IStyles, mediaCSS, grid, palette } from '../../theme'

const NotificationСenter: IStyles = {
    tabsWrapper: {
        marginBottom: -36,
        [mediaCSS.tab]: {
            paddingTop: 60,
        },
    },
    tabsSurface: {
        padding: '20px 20px 0',
        backgroundColor: palette.white,
        borderRadius: '12px 12px 0 0',
    },
    contentWrapper: {
        [mediaCSS.tab]: {
            paddingTop: 60,
        },
    },
    retentionRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 14,
    },
    caption: {
        display: 'flex',
        color: palette.neutral,
        fontSize: 13,
        lineHeight: '18px',
    },
    changeSettings: {
        marginLeft: 16,
        color: palette.brandBlue.main,
        cursor: 'pointer',
    },
    toolbarRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 20,
        marginBottom: 14,
    },
    group: {
        display: 'flex',
        alignItems: 'center',
        gap: 20,
    },
    table: {
        width: '100%',
        overflowX: 'auto',
        borderRadius: 4,
        backgroundColor: palette.white,
    },
    tableGrid: {
        display: 'grid',
        gridTemplateColumns: '42px minmax(108px, 0.7fr) minmax(140px, 0.9fr) minmax(300px, 3fr) 36px',
        alignItems: 'center',
        minWidth: 720,
        color: palette.neutral[850],
    },
    tableHeader: {
        minHeight: 38,
        padding: '0 10px',
        backgroundColor: palette.neutral[100],
        color: palette.neutral,
        fontSize: 12,
        lineHeight: '16px',
        fontWeight: 500,
    },
    tableRow: {
        minHeight: 72,
        padding: '8px 10px',
        borderBottom: `1px solid ${palette.black[100]}`,
        color: palette.neutral,
        fontSize: 13,
        lineHeight: '18px',
        transition: 'background-color 140ms ease',
        '&:hover': {
            backgroundColor: '#F7F9FC',
        },
    },
    unreadRow: {
        backgroundColor: palette.info[100],
    },
    checkboxCell: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    dateCell: {
        display: 'flex',
        flexDirection: 'column',
        color: palette.neutral,
        whiteSpace: 'nowrap',
    },
    statusCell: {
        color: palette.brandBlue,
        fontSize: 12,
        lineHeight: '16px',
    },
    statusError: {
        color: `${palette.error} !important`,
    },
    statusWarning: {
        color: `${palette.warning} !important`,
    },
    eventCell: {
        display: 'flex',
        minWidth: 0,
        flexDirection: 'column',
        paddingRight: 16,
    },
    eventTitle: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    eventMeta: {
        overflow: 'hidden',
        color: palette.black[400],
        fontSize: 12,
        lineHeight: '16px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    rowAction: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    detailsButton: {
        appearance: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 32,
        height: 32,
        padding: 0,
        border: 0,
        borderRadius: 4,
        background: 'transparent',
        cursor: 'pointer',

        '&:focus-visible': {
            outline: `2px solid ${palette.brandBlue}`,
        },
    },
    emptyState: {
        padding: '48px 20px',
        textAlign: 'center',
    },
    modal: {
        ...grid.w50,
        [mediaCSS.tab]: {
            ...grid.w60,
        },
        [mediaCSS.tabMini]: {
            ...grid.w70,
        },
        [mediaCSS.mob]: {
            ...grid.w90,
        },
        ...grid.p_none,
    },
    wrapper: {
        width: '100%',
        marginBottom: 20,
        borderRadius: '10px 10px 0 0',
    },
    textModal: {
        width: '100%',
        paddingLeft: 20,
    },
    headerModal: {
        display: 'flex',
        alignItems: 'center',
        margin: '20px 0',
        paddingLeft: 20,
        textAlign: 'center',
    },
    opacity: {
        opacity: 0.8,
    },
    opacity9: {
        opacity: 0.9,
    },
    nameText: {
        overflow: 'hidden',
        maxWidth: 250,
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
}

addStyles(NotificationСenter)
export default NotificationСenter
